/**
 * RESPONSIBILITY: the Children's Ministry page's opening band.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Img } from '@framework/core/decorators';
import type { ImageValue } from '@framework/core';
import { SectionName } from '../section-names';

@Section({ name: SectionName.ChildrenHero, label: "Children — hero" })
export class ChildrenHeroSection {
  @Text({ label: 'Title', maxLength: 300, default: "Children's Ministry at ACFI" })
  heroTitle!: string;

  @Img({
    label: 'Background image', folder: 'children', maxSizeMb: 12, size: '1920 × 1080',
    description: 'Fills the band behind the title.',
  })
  heroImage!: ImageValue;
}
